import { render } from "./datav.vue?vue&type=template&id=40aa89ef"
import script from "./datav.vue?vue&type=script&lang=js"
export * from "./datav.vue?vue&type=script&lang=js"

import "./datav.vue?vue&type=style&index=0&id=40aa89ef&lang=css"

import exportComponent from "E:\\Projects\\YCTECH\\ycform\\trunk\\ycform-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__